import { useUsuario } from '../contexts/UsuarioContext'

export function useFaturamentoPermissions() {
  const { usuario } = useUsuario()

  // Garantir que papeis seja um array de strings para comparação
  const papeis = usuario?.papeis || []
  const papeisNormalizados = Array.isArray(papeis) 
    ? papeis.map((p: any) => String(p)) 
    : []

  const isAdmin = papeisNormalizados.includes('1')
  const isAnalista = !isAdmin && papeisNormalizados.includes('2')

  return {
    isAdmin,
    isAnalista,
    isLoading: !usuario
  }
}



